import { kebabCase } from 'lodash';

const supportedQueries: string[] = ['max-width', 'min-width'];

export class MediaBuilder {
  static media(mediaString: string): string {
    const mediaCase = kebabCase(mediaString);
    return this.toMediaString(mediaCase);
  }

  private static toMediaString = (str: string): string => {
    // try to find media query in string
    let result: { query: any; value: any; };

    for (const q of supportedQueries) {
      const array = str.split(q);
      if (array.length > 1) {
        const [, val] = array;
        const res = val.replace(/-/gi, '');
        result = {query: q, value: res};
        break;
      }
    }

    const mediaValue =
      result === undefined ? str : `(${result.query}: ${result.value})`;

    return `@media ${mediaValue}`;
  };
}
